var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { gql, useQuery } from '@apollo/client';
import { useDynamicValues } from '@doordash/component-dynamic-values';
import * as React from 'react';
import * as Sentry from '@sentry/react';
import { useSelector } from 'react-redux';
import { identifyConsumer } from '../../utils/useTelemetry';
import { getTeamId } from '../../selectors/portal_selector';
import { getSelectedTeamAccount } from '../../selectors/uiSelector';
import { readCookie } from '../../utils/cookie_helper';
export var BOOTSTRAP_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query workPortalBootstrap {\n    workPortalBootstrap {\n      dynamicValues\n      consumerId\n      isGuest\n    }\n  }\n"], ["\n  query workPortalBootstrap {\n    workPortalBootstrap {\n      dynamicValues\n      consumerId\n      isGuest\n    }\n  }\n"])));
export var useBootstrapData = function () {
    return useQuery(BOOTSTRAP_QUERY);
};
export var useBootstrapDataAndConfigureGlobalUserContext = function () {
    var _a = useBootstrapData(), data = _a.data, loading = _a.loading;
    var _b = __read(React.useState(false), 2), identifiedUser = _b[0], setIdentifiedUser = _b[1];
    React.useEffect(function () {
        var _a, _b;
        var consumerId = (_b = (_a = data === null || data === void 0 ? void 0 : data.workPortalBootstrap) === null || _a === void 0 ? void 0 : _a.consumerId) !== null && _b !== void 0 ? _b : '';
        if (!identifiedUser && consumerId) {
            setIdentifiedUser(true);
            identifyConsumer(consumerId);
            Sentry.setUser({ id: consumerId });
        }
    }, [identifiedUser, setIdentifiedUser, data]);
    return {
        data: data,
        loading: loading,
    };
};
export var useGetConsumerInfo = function () {
    var _a, _b;
    var _c = useBootstrapData(), data = _c.data, loading = _c.loading, error = _c.error;
    return {
        loading: loading,
        error: error,
        consumerId: ((_a = data === null || data === void 0 ? void 0 : data.workPortalBootstrap) === null || _a === void 0 ? void 0 : _a.consumerId) || '',
        isGuest: ((_b = data === null || data === void 0 ? void 0 : data.workPortalBootstrap) === null || _b === void 0 ? void 0 : _b.isGuest) === false ? false : true,
    };
};
/**
 * Given a DV name and an additional context object, determine if the DV (boolean)
 * is enabled. Well known properties such as team id, consumer id, device id are
 * merged with `overrideContext` for the DV determination
 */
export var useIsDynamicBooleanEnabled = function (dvName, overrideContext) {
    if (overrideContext === void 0) { overrideContext = {}; }
    var dv = useDynamicValues();
    var _a = useGetConsumerInfo(), consumerId = _a.consumerId, isGuest = _a.isGuest;
    var teamId = useSelector(getTeamId) || '';
    var teamAccountId = useSelector(getSelectedTeamAccount) || '';
    var consumerContext = { consumerId: consumerId, isGuest: isGuest };
    var teamRelatedContext = {
        teamId: teamId,
        teamAccountId: teamAccountId,
    };
    var cookiesBasedContext = {
        deviceId: readCookie('dd_device_id') || '',
    };
    var finalMergedContextObject = __assign(__assign(__assign(__assign({}, cookiesBasedContext), teamRelatedContext), consumerContext), overrideContext);
    return dv.getBoolean(dvName, finalMergedContextObject);
};
var templateObject_1;
